var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright-area copyright-style-one"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"copyright-right text-center"},[_c('p',{staticClass:"copyright-text"},[_vm._v(" "+_vm._s(_vm.$t('Footer.copyright', { year: new Date().getFullYear() }))+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }